'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var _func_1 = require("./_func");
var OrderOther;
(function (OrderOther) {
    var MyOrderOther = /** @class */ (function () {
        function MyOrderOther() {
            var self = this;
            $(window).ready(function () {
                // 支払い方法選択ページ
                if ($('#paramThisIsOrderDeliveryPage').val() == "1") {
                    // パラメーター値を表示に反映
                    var D = MyOrderOther.getParameters();
                    console.log(D);
                    MyOrderOther.setInitialSelect(D);
                    MyOrderOther.setInitialButtonView(D);
                }
            });
            // 注文：選択肢
            $(document).on('click', '.trigOtherSelect', function () {
                var name = $(this).attr('data-name');
                var value = $(this).attr('data-value');
                // console.log([name, value]);
                // 共通処理
                MyOrderOther.setThisButton(name, value);
                MyOrderOther.setInputValue(name, value);
                var open = $(this).attr('data-open');
                var close = $(this).attr('data-close');
                MyOrderOther.showOption(open, close);
            });
            // カード番号から会社を選択
            $(document).on('keyup', '.trigChangeCreditCompany', function () {
                var value = $(this).val();
                var company = _func_1.default.getCreditCompany(value);
                MyOrderOther.changeCreditCompany(company);
            });
            // マップから住所を使用
            $(document).on('click', '.trigUseThisAddress', function () {
                var data = MyOrderOther.getAddressData($(this));
                MyOrderOther.setAddressData(data);
                $('#bulletGoogleMapAPI').hide();
                $('#bulletNewAddressName').focus();
            });
            // マップを消す
            $(document).on('click', '#trigCloseGoogleMap', function () {
                $('#bulletGoogleMapAPI').hide();
            });
            // 注文：入力
            $(document).on('keyup', '.trigAutoFocus', function () {
                var valueLength = $(this).val().length;
                if (valueLength == 4) {
                    $(this).next().focus();
                }
            });
        }
        MyOrderOther.getParameters = function () {
            var D = {
                deliveryId: $('input[name="delivery_id"]').val(),
                addressId: $('input[name="address_id"]').val(),
                addressAction: $('input[name="address_action"]').val(),
                paymentId: $('input[name="payment_id"]').val(),
                cardId: $('input[name="card_id"]').val(),
                cardAction: $('input[name="card_action"]').val(),
            };
            return D;
        };
        MyOrderOther.setInitialSelect = function (D) {
            MyOrderOther.setThisButton('delivery_id', D.deliveryId);
            MyOrderOther.setThisButton('address_id', D.addressId);
            MyOrderOther.setThisButton('address_action', D.addressAction);
            MyOrderOther.setThisButton('payment_id', D.paymentId);
            MyOrderOther.setThisButton('card_id', D.cardId);
            MyOrderOther.setThisButton('card_action', D.cardAction);
        };
        MyOrderOther.setInputValue = function (name, value) {
            $('.bulletOtherSelect[data-name="' + name + '"]').val(value);
        };
        // Button
        MyOrderOther.setThisButton = function (name, value) {
            $('.trigOtherSelect[data-name="' + name + '"]').removeClass('selected');
            $('.trigOtherSelect[data-name="' + name + '"][data-value="' + value + '"]').addClass('selected');
        };
        MyOrderOther.showOption = function (open, close) {
            $('.bulletOtherOption[data-name="' + open + '"]').show();
            $('.bulletOtherOption[data-name="' + close + '"]').hide();
        };
        MyOrderOther.changeCreditCompany = function (company) {
            $('.bulletChangeCreditCompany').hide();
            $('.bulletChangeCreditCompany[data-company="' + company + '"]').show();
            $('#card_company').html(company);
        };
        MyOrderOther.getAddressData = function (elm) {
            var data = {
                zip1: elm.attr('data-zip1'),
                zip2: elm.attr('data-zip2'),
                pref: elm.attr('data-pref'),
                city: elm.attr('data-city'),
                address: elm.attr('data-address'),
                lat: elm.attr('data-lat'),
                lng: elm.attr('data-lng'),
            };
            return data;
        };
        MyOrderOther.setAddressData = function (data) {
            $('#zip1').val(data.zip1);
            $('#zip2').val(data.zip2);
            _func_1.default.setSelectValue('#pref_id', data.pref);
            $('#city').val(data.city);
            $('#address').val(data.address);
            $('#lat').val(data.lat);
            $('#lng').val(data.lng);
        };
        MyOrderOther.setInitialButtonView = function (D) {
            if (D.deliveryId == 'DV02') {
                $('.bulletOtherOption[data-name="delivery_id"]').show();
                if (D.addressAction == 'select') {
                    $('.bulletOtherOption[data-name="select-address"]').show();
                }
                else if (D.addressAction == 'entry') {
                    $('.bulletOtherOption[data-name="entry-address"]').show();
                }
            }
            if (D.paymentId == 'credit') {
                $('.bulletOtherOption[data-name="payment_id"]').show();
                if (D.cardAction == 'select') {
                    $('.bulletOtherOption[data-name="select-card"]').show();
                }
                else if (D.cardAction == 'entry') {
                    $('.bulletOtherOption[data-name="entry-card"]').show();
                }
            }
        };
        return MyOrderOther;
    }());
    OrderOther.MyOrderOther = MyOrderOther;
})(OrderOther || (OrderOther = {}));
exports.default = OrderOther;
